import 'css-chunksrc/client/common/projectsSelection/styles.scss';export default {
  "projectsSelection": "_projectsSelection_y1utk_1",
  "root": "_root_y1utk_12",
  "search": "_search_y1utk_18",
  "list": "_list_y1utk_22"
};